module.exports = __webpack_public_path__ + "img/grazi_menu_1.0af65652.png";